import React, { useEffect, useState } from 'react';
import { gql, useQuery } from '@apollo/client';
import client from '@gql/client';
import { Template } from '../../template';
import { LoadingBox } from '@assets/tsx/loadingBox/loadingBox';
export function TemplateContent(id) {
    const [innerContent, setInnerContent] = useState({
        css: undefined,
        postId: undefined,
        sections: undefined
    });
    const { data, loading } = useQuery(gql `
		query ELEMENTOR_TEMPLATE($id:ID!) {
			elementorTemplate(id: $id) {
				elementorData
				id
				css {
					href
					id
				}
			}
		}
	`, {
        variables: {
            id: id,
        },
        client
    });
    useEffect(() => {
        var _a, _b;
        const result = data === null || data === void 0 ? void 0 : data.elementorTemplate;
        if (!result)
            return;
        const css = (_b = (_a = result === null || result === void 0 ? void 0 : result.css) === null || _a === void 0 ? void 0 : _a.at(0)) === null || _b === void 0 ? void 0 : _b.href;
        const postId = result === null || result === void 0 ? void 0 : result.id;
        let sections = [];
        try {
            sections = JSON.parse(result === null || result === void 0 ? void 0 : result.elementorData);
        }
        catch (err) {
            console.warn(err);
        }
        setInnerContent({
            css,
            postId,
            sections
        });
    }, [data]);
    // if (true) return(<>
    if (loading)
        return (React.createElement(React.Fragment, null,
            React.createElement(LoadingBox, { style: { height: 600 } })));
    return React.createElement(Template, Object.assign({}, innerContent));
}
